import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Link } from "react-router-dom";
import { ToastifyAlert } from "../../CommonComponents/ToastifyAlert";
import { hasStoreUrlPermission } from "../../helperFunctions/storePermissionHelper";
import { useSelector, useDispatch } from "react-redux";
import { generateClass } from "../../Constants/utils";

const NestedDropdownMenu = ({
  item,
  isMenuOpenRedux,
  activeItem,
  dropDownItem,
  hoveredItem,
  handleToggleDropdownItems,
  activeNestedItem,
  setActiveNestedItem,
  setDropDownItem,
  activeDropDownItem,
  isTabletNav,
}) => {
  const dispatch = useDispatch();

  const handleNestedClick = (id) => {
    setActiveNestedItem((prevId) => (prevId === id ? null : id));
  };
  // Keep nested section open after choosing a child (don't toggle closed).
  const keepNestedSectionOpen = (id) => {
    setActiveNestedItem(id);
  };
  return (
    <div
      className={`qv-app-sidebar__nested ${item.className} w-full items-center cursor-pointer hover:text-[#F5F9FF] hover:bg-[#526167] text-[#9E9E9E]`}
    >
      {isMenuOpenRedux ? (
        <>
          <div>
            <div
              onClick={(e) => {
                handleNestedClick(item.id);
                e.stopPropagation();
              }}
              className={`qv-app-sidebar__nested-trigger w-full flex items-center hover:bg-[#526167] justify-between cursor-pointer
              ${activeNestedItem === item.id ? "qv-app-sidebar__nested-trigger--active bg-[#526167] " : ""}
              `}
              title={item.text}
            >
              <p
                className={`qv-app-sidebar__nested-label text-[14px] p-4 Admin_std ${
                  activeNestedItem === item.id ? "text-[#F5F9FF] " : ""
                }`}
              >
                {item?.text}
              </p>

              {activeNestedItem === item.id ? (
                <FaChevronUp
                  className={`qv-app-sidebar__chevron quickarrow_icon me-4 text-${
                    (activeNestedItem === item.id ||
                      hoveredItem === item?.id) &&
                    "[#F5F9FF]"
                  }`}
                />
              ) : (
                <FaChevronDown
                  className={`qv-app-sidebar__chevron quickarrow_icon me-4 text-${
                    (activeNestedItem === item.id ||
                      hoveredItem === item?.id) &&
                    "[#]"
                  }`}
                />
              )}

              {/* <FaChevronDown
                className={`quickarrow_icon me-4 text-${
                  ( activeNestedItem === item.id  || hoveredItem === item?.id) &&
                  "[#F5F9FF]"
                }`}
              /> */}
            </div>
          </div>
        </>
      ) : (
        <>{/* for icons */}</>
      )}

      {activeNestedItem === item.id &&
        item?.dropDownItems?.length &&
        item?.dropDownItems?.map((NestedItem) => (
          <div className="qv-app-sidebar__nested-row" key={NestedItem.id}>
            <Link
              to={NestedItem.link}
              aria-current={activeItem === NestedItem.link ? "page" : undefined}
              title={NestedItem.text}
              className={`qv-app-sidebar__nested-link ${NestedItem?.className} flex nested-submenu-item ps-6 hover:text-[#FFC400] text-center text-[#9E9E9E] py-3 text-[14px]
              ${activeItem === NestedItem.link ? "qv-app-sidebar__nested-link--active text-[#FFC400]" : ""}`}
              onClick={(e) => {
                if (!hasStoreUrlPermission("/merchants" + NestedItem.link)) {
                  e.preventDefault();
                  ToastifyAlert("Access Denied", "error");
                  return;
                }
                handleToggleDropdownItems(NestedItem, e);
                if (!(e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1)) {
                  keepNestedSectionOpen(item.id);
                }
                e.stopPropagation();
              }}
            >
              {NestedItem.text}
            </Link>
          </div>
        ))}
    </div>
  );
};

export default NestedDropdownMenu;
